var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#0098FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.8 49.2678L72.057 32.0108C72.6725 31.3953 73.017 30.5641 73.017 29.6949C73.017 28.8271 72.6712 27.9932 72.0583 27.3803L53.6366 8.95864C53.0224 8.34441 52.1898 8 51.322 8C50.4542 8 49.6217 8.34441 49.0075 8.95864L12.9586 45.0075C12.3444 45.6217 12 46.4529 12 47.322C12 48.1898 12.3458 49.0237 12.9586 49.6366L31.3803 68.0583C31.9946 68.6725 32.8271 69.017 33.6949 69.017C34.5627 69.017 35.3953 68.6725 36.0095 68.0583L47.3925 56.6753",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7795 39.1865L41.8304 62.2373",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7444 53.2867L27.7301 56.2724",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2091 21.7034C46.3012 21.7034 46.3758 21.778 46.3758 21.87C46.3758 21.9621 46.3012 22.0367 46.2091 22.0367C46.1171 22.0367 46.0425 21.9621 46.0425 21.87C46.0425 21.778 46.1171 21.7034 46.2091 21.7034Z",
    fill: "#0098FF",
    stroke: "#0098FF",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2768 17.6356C50.3688 17.6356 50.4434 17.7102 50.4434 17.8023C50.4434 17.8943 50.3688 17.969 50.2768 17.969C50.1847 17.969 50.1101 17.8943 50.1101 17.8023C50.1101 17.7102 50.1847 17.6356 50.2768 17.6356Z",
    fill: "#0098FF",
    stroke: "#0098FF",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1413 25.7712C42.2333 25.7712 42.3079 25.8458 42.3079 25.9378C42.3079 26.0299 42.2333 26.1045 42.1413 26.1045C42.0492 26.1045 41.9746 26.0299 41.9746 25.9378C41.9746 25.8458 42.0492 25.7712 42.1413 25.7712Z",
    fill: "#0098FF",
    stroke: "#0098FF",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4915 88V83.9322C21.4915 82.4339 22.705 81.2203 24.2033 81.2203H51.322C52.8203 81.2203 54.0338 82.4339 54.0338 83.9322V88",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9206 81.2203L21.8196 73.3125C20.7063 70.4746 20.1355 67.4522 20.1355 64.4027V56.8135",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9999 48L61.3333 50.6667",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3333 34.6667L68 44",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 86.8333C27.092 86.8333 27.1666 86.9079 27.1666 87C27.1666 87.092 27.092 87.1666 26.9999 87.1666C26.9079 87.1666 26.8333 87.092 26.8333 87C26.8333 86.9079 26.9079 86.8333 26.9999 86.8333Z",
    fill: "#0098FF",
    stroke: "#0098FF",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6354 81.2379L58.4611 67.8318C59.0984 66.5559 59.4577 65.1173 59.4577 63.5932C59.4577 62.4908 59.2652 61.5444 58.8882 60.5071L53.7465 46.3688C53.0808 44.5505 51.3357 43.2542 49.2882 43.2542C46.6672 43.2542 44.5425 45.379 44.5425 48C44.5425 48.5681 44.6428 49.1132 44.8259 49.6176L49.3032 61.9308",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6667 80H76.0001",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84 80H89.3333",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80 84V89.3333",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80 70.6667V76",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.246a4b457d8613f87f0251f377f3f3c6.svg";
export { ForwardRef as ReactComponent };